import { render, staticRenderFns } from "./findMenuPage.vue?vue&type=template&id=4b918542&scoped=true"
import script from "./findMenuPage.vue?vue&type=script&lang=js"
export * from "./findMenuPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b918542",
  null
  
)

export default component.exports